import React from "react";

function CountdownPill({ children }) {
  return <div className="countdown__pill">{children}</div>;
}

export default CountdownPill;
